import { useTranslation, Trans } from "react-i18next";

import prize from '../../img/SpecialOffers/priz.png'

import { Fade } from 'react-awesome-reveal'

function Prizes() {

  const { t } = useTranslation();

  return (
    <div className="relative pt-[80px] xl:pt-[160px] overflow-hidden">
      <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
        <div className="flex flex-col xl:flex-row gap-[20px] justify-between">
            <div className="xl:mt-[35px]">
                <p className="zen-dots leading-[1.2] text-[24px] xl:text-[36px] text-[#1E1C21] xl:max-w-[595px]">
                    <Trans>{t("offers.16")}</Trans>
                </p>
                <div className="flex gap-[10px] mt-[30px] xl:mt-[40px]">
                    <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0 mt-[10px]"></div>
                    <div>
                        <p className="text-[14px] xl:text-[16px] text-[#1E1C21] font-[500] ibm-plex">{t('offers.17')}</p>
                        <p className="text-[#000000B2] max-w-[476px] text-[12px] xl:text-[14px] ibm-plex mt-[4px]">{t('offers.18')}</p>
                    </div>
                </div>
                <div className="flex gap-[10px] mt-[12px] xl:mt-[18px]">
                    <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0 mt-[10px]"></div>
                    <div>
                        <p className="text-[14px] xl:text-[16px] text-[#1E1C21] font-[500] ibm-plex">{t('offers.19')}</p>
                        <p className="text-[#000000B2] max-w-[476px] text-[12px] xl:text-[14px] ibm-plex mt-[4px]">{t('offers.20')}</p>
                    </div>
                </div>
                <div className="flex gap-[10px] mt-[12px] xl:mt-[18px]">
                    <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0 mt-[10px]"></div>
                    <div>
                        <p className="text-[14px] xl:text-[16px] text-[#1E1C21] font-[500] ibm-plex">{t('offers.21')}</p>
                        <p className="text-[#000000B2] max-w-[476px] text-[12px] xl:text-[14px] ibm-plex mt-[4px]">{t('offers.22')}</p>
                    </div>
                </div>
                <div className="flex gap-[10px] mt-[12px] xl:mt-[18px]">
                    <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0 mt-[10px]"></div>
                    <div>
                        <p className="text-[14px] xl:text-[16px] text-[#1E1C21] font-[500] ibm-plex">{t('offers.23')}</p>
                        <p className="text-[#000000B2] max-w-[476px] text-[12px] xl:text-[14px] ibm-plex mt-[4px]">{t('offers.24')}</p>
                    </div>
                </div>
                <div className="flex gap-[10px] mt-[12px] xl:mt-[18px]">
                    <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0 mt-[10px]"></div>
                    <div>
                        <p className="text-[14px] xl:text-[16px] text-[#1E1C21] font-[500] ibm-plex">{t('offers.25')}</p>
                        <p className="text-[#000000B2] max-w-[476px] text-[12px] xl:text-[14px] ibm-plex mt-[4px]">{t('offers.26')}</p>
                    </div>
                </div>
            </div>
            <Fade><img src={prize} className="mt-[40px] xl:mt-0" alt="" /></Fade>
        </div>
      </div>
    </div>
  );
}

export default Prizes;
